// src/components/GlobalBar.tsx
import "./GlobalBar.module.css";

export default function GlobalBar() {
  return <div className="global-bar"></div>;
}
